/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateInquiryDto } from '../../models/create-inquiry-dto';
import { InquiryDto } from '../../models/inquiry-dto';

export interface InquiryControllerCreate$Params {
  vendorWorkspaceId?: string;
  clientWorkspaceId?: string;
      body: CreateInquiryDto
}

export function inquiryControllerCreate(http: HttpClient, rootUrl: string, params: InquiryControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<InquiryDto>> {
  const rb = new RequestBuilder(rootUrl, inquiryControllerCreate.PATH, 'post');
  if (params) {
    rb.query('vendorWorkspaceId', params.vendorWorkspaceId, {});
    rb.query('clientWorkspaceId', params.clientWorkspaceId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InquiryDto>;
    })
  );
}

inquiryControllerCreate.PATH = '/api/v1/inquiry';
